import { string } from 'prop-types';

const salesTaxBasicInformationPropTypes = {
  name: string.isRequired,
  description: string
};

export default salesTaxBasicInformationPropTypes;
